//import all svg files for infoicons
const reqSvgInfo = require.context(
  "src/Components/HomePage/Components/03-InfoIconsSection/Assets/Icons/",
  true,
  /\.svg$/
);
const svgFileInfoPaths = reqSvgInfo.keys();

//import all svg files for App Stores
const reqSvgApp = require.context(
  "src/Common/Assets/Icons/AppStore/",
  true,
  /\.svg$/
);
const svgFileAppPaths = reqSvgApp.keys();

/*----- REGION : MY -----*/

//---Banner---
export const bannerHeaderEng = "WELCOME TO SHOPEE PAY!";
export const bannerHeaderMy = "Selamat Datang di ShopeePay!";
export const bannerHeaderVn = "Chào mừng bạn đến với ShopeePay!";
export const bannerHeaderVnEng = "Welcome to ShopeePay!";
//Banner Subtitles 
export const bannerSubtitleEng = "A secure e-Wallet that allows you to pay for your online and offline deals.";
export const bannerSubtitleMy = "Metode pembayaran dari E-commerce #1 \n di Indonesia!";
export const bannerSubtitleVn = "ShopeePay đáp ứng mọi nhu cầu thanh toán của bạn một cách nhanh chóng, mọi lúc mọi nơi, an toàn và bảo mật thông tin cao.";
export const bannerSubtitleVnEng = "ShopeePay meets all your payment needs quickly, anytime, anywhere with high information security.";
//Download
export const bannerDownloadEng = "DOWNLOAD SHOPEE NOW";
export const bannerDownloadMy = "Download sekarang";
export const bannerDownloadVn = "Kích hoạt Ví ShopeePay trên app Shopee ngay!";
export const bannerDownloadVnEng = "Activate ShopeePay on Shopee app now!";

export const bannerAppStoresEng = [
  {
    img: reqSvgApp(svgFileAppPaths[0]),
    link: " https://apps.apple.com/vn/app/id959841449 ",
    description: "Apple Store",
    width: "120px",
  },
  {
    img: reqSvgApp(svgFileAppPaths[1]),
    link: "https://play.google.com/store/apps/details?id=com.shopee.vn&referrer=af_tranid%3Drsx9V4J79OX3NH5LwyqLcw%26pid%3DOrganicA%26c%3Dlp_home_and1",
    description: "Google Play",
    width: "120px",
  },
  {
    img: reqSvgApp(svgFileAppPaths[2]),
    link: "https://appgallery.cloud.huawei.com/ag/n/app/C101433653?channelId=web&detailType=0",
    description: "Hua Wei Store",
    width: "120px",
  },
];

export const bannerAppStoresMy = [
  {
    img: reqSvgApp(svgFileAppPaths[0]),
    link: " https://apps.apple.com/vn/app/id959841449 ",
    description: "Apple Store",
    width: "120px",
  },
  {
    img: reqSvgApp(svgFileAppPaths[1]),
    link: "https://play.google.com/store/apps/details?id=com.shopee.vn&referrer=af_tranid%3Drsx9V4J79OX3NH5LwyqLcw%26pid%3DOrganicA%26c%3Dlp_home_and1",
    description: "Google Play",
    width: "120px",
  },
  {
    img: reqSvgApp(svgFileAppPaths[2]),
    link: "https://appgallery.cloud.huawei.com/ag/n/app/C101433653?channelId=web&detailType=0",
    description: "Hua Wei Store",
    width: "120px",
  },
];


export const bannerAppStoresVn = [
  {
    img: reqSvgApp(svgFileAppPaths[0]),
    link: "https://apps.apple.com/vn/app/id959841449",
    description: "Apple Store",
    width: "120px",
  },
  {
    img: reqSvgApp(svgFileAppPaths[1]),
    link: "https://play.google.com/store/apps/details?id=com.shopee.vn&referrer=af_tranid%3Drsx9V4J79OX3NH5LwyqLcw%26pid%3DOrganicA%26c%3Dlp_home_and1 ",
    description: "Google Play",
    width: "120px",
  },
  {
    img: reqSvgApp(svgFileAppPaths[2]),
    link: "https://appgallery.cloud.huawei.com/ag/n/app/C101433653?channelId=web&detailType=0",
    description: "Hua Wei Store",
    width: "120px",
  },
];

//---introIconsSection---
//header
export const introHeaderEng = "About ShopeePay";
export const introHeaderMy = "Tentang ShopeePay";
export const introHeaderVn = "Giới thiệu về Ví điện tử ShopeePay";
//subtitle
export const introSubtitleEng = "ShopeePay is a mobile wallet that makes cashless payments quick and easy! With ShopeePay, you can enjoy discounts and promotions, pay bills and make in-store purchases all in one app.";
export const introSubtitleMy = "ShopeePay adalah fitur layanan uang elektronik yang dapat digunakan sebagai metode pembayaran online di aplikasi Shopee, offline di Merchant ShopeePay, dan menyimpan pengembalian dana yang dapat digunakan untuk membayar pesanan Anda berikutnya.";
export const introSubtitleVn = "Ví điện tử ShopeePay cho phép người dùng thanh toán trực tuyến trên Shopee - sàn thương mại điện tử số 1 Việt Nam, thanh toán hóa đơn, nạp điện thoại, chuyển tiền và thanh toán bằng cách quét mã QR ngay tại cửa hàng";
export const introSubtitleVnEng = "ShopeePay is an e-wallet that allows users to make online transactions on Shopee - Vietnam's No. 1 e-commerce platform, pay bills, recharge mobile phones, transfer money and make payments by payment method. scan the QR code at the store";

//---infoiconsSection---
//header
export const infoIconsHeaderEng = "Benefits of Using ShopeePay";
export const infoIconsHeaderMy = "Banyaknya Keuntungan  Menggunakan ShopeePay";
export const infoIconsHeaderVn = "Lợi ích khi sử dụng Ví ShopeePay";
//icons
export const infoIconsEng = [
  {
    icon: reqSvgInfo(svgFileInfoPaths[0]),
    description: "",
    width: "110px",
    h2Text: "Exclusive Vouchers",
    bodyText:
      'Get special Cashback Vouchers worth up to RM4 on "Deals Near Me" via Shopee App to redeem at your favourite stores!',
  },
  {
    icon: reqSvgInfo(svgFileInfoPaths[1]),
    description: "",
    width: "110px",
    h2Text: "Exclusive Vouchers",
    bodyText:
      'Get special Cashback Vouchers worth up to RM4 on "Deals Near Me" via Shopee App to redeem at your favourite stores!',
  },
  {
    icon: reqSvgInfo(svgFileInfoPaths[2]),
    description: "",
    width: "110px",
    h2Text: "Exclusive Vouchers",
    bodyText:
      'Get special Cashback Vouchers worth up to RM4 on "Deals Near Me" via Shopee App to redeem at your favourite stores!',
  },
  {
    icon: reqSvgInfo(svgFileInfoPaths[4]),
    description: "",
    width: "110px",
    h2Text: "Exclusive Vouchers",
    bodyText:
      'Get special Cashback Vouchers worth up to RM4 on "Deals Near Me" via Shopee App to redeem at your favourite stores!',
  },
];

export const infoIconsMy = [
    {
        icon: reqSvgInfo ( svgFileInfoPaths[0] ),
        description:"",
        width:"110px",
        h2Text: "Voucher ShopeePay",
        bodyText: "Dapatkan penawaran Voucher Cashback hingga 30% untuk digunakan di Merchant favoritmu.",
    },
    {
        icon: reqSvgInfo ( svgFileInfoPaths[1] ),
        description:"",
        width:"110px",
        h2Text: "Cashback Setiap Hari",
        bodyText: "Belanja di aplikasi Shopee atau Merchant favoritmu pakai ShopeePay dan dapatkan Cashback Koin Shopee.",
    },
    {
        icon: reqSvgInfo ( svgFileInfoPaths[2] ),
        description:"",
        width:"110px",
        h2Text: "Transfer Cepat dan Mudah",
        bodyText: "Transfer ShopeePay ke temanmu di mana saja dan kapan saja tanpa biaya tambahan.",
    },
    {
        icon: reqSvgInfo ( svgFileInfoPaths[4] ),
        description:"",
        width:"110px",
        h2Text: "Gratis Ongkir Lebih Banyak",
        bodyText: "Belanja pakai ShopeePay dan dapatkan Voucher Cashback serta Gratis Ongkir!",
    },
]

export const infoIconsVn = [
    {
        icon: reqSvgInfo ( svgFileInfoPaths[0] ),
        description:"",
        width:"110px",
        h2Text: "Đa dạng dịch vụ",
        bodyText: "Thanh toán giao dịch thương mại điện tử, thanh toán hóa đơn, nạp điện thoại, và các dịch vụ khác vô cùng nhanh chóng và tiện lợi",
    },
    {
        icon: reqSvgInfo ( svgFileInfoPaths[1] ),
        description:"",
        width:"110px",
        h2Text: "Thanh toán Scan&Pay - quét QR",
        bodyText: "Quét mã QR tại cửa hàng để thanh toán an toàn, tiện lợi và đặc biệt không cần tiền mặt",
    },
    {
        icon: reqSvgInfo ( svgFileInfoPaths[2] ),
        description:"",
        width:"110px",
        h2Text: "Chuyển tiền nhanh chóng",
        bodyText: "Chuyển tiền cho bạn bè qua Ví ShopeePay nhanh chóng và bảo mật",
    },
    {
        icon: reqSvgInfo ( svgFileInfoPaths[3] ),
        description:"",
        width:"110px",
        h2Text: "An toàn bảo mật",
        bodyText: "Liên kết tài khoản với các ngân hàng hàng đầu Việt Nam. An toàn bảo mật với Tiêu chuẩn PCI DSS",
    },
]

export const infoIconsVnEng = [
    {
        icon: reqSvgInfo ( svgFileInfoPaths[0] ),
        description:"",
        width:"110px",
        h2Text: "Diversity of services",
        bodyText: "Pay e-commerce transactions, pay bills, topup phones, and other services extremely fast and convenient",
    },
    {
        icon: reqSvgInfo ( svgFileInfoPaths[1] ),
        description:"",
        width:"110px",
        h2Text: "Scan&Pay payment - scan QR",
        bodyText: "Scan the QR code at the store to pay securely and especially without cash",
    },
    {
        icon: reqSvgInfo ( svgFileInfoPaths[2] ),
        description:"",
        width:"110px",
        h2Text: "Fast money transfer",
        bodyText: "Transfer money to friends via ShopeePay Wallet quickly and securely",
    },
    {
        icon: reqSvgInfo ( svgFileInfoPaths[3] ),
        description:"",
        width:"110px",
        h2Text: "Safety and security",
        bodyText: "Link accounts with leading banks in Vietnam. Security with PCI DSS Standard",
    },
]
